import { Component, OnInit } from '@angular/core';
import { IconBaseComponent } from '../icon-base/icon-base.component';

@Component({
  selector: 'app-icon-building',
  templateUrl: './icon-building.component.html',
  styleUrls: ['./icon-building.component.scss']
})
export class IconBuildingComponent extends IconBaseComponent implements OnInit {
  constructor() {
    super();
  }

  ngOnInit(): void {}
}
